import React, { useState,useEffect } from "react";
import { configData } from "../config";
import { useLocation,useNavigate,useSearchParams, useParams, Link  } from 'react-router-dom';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';
import ManageReferrals from "./ManageReferrals";
import './classes/CashOut.css';


const CashOut = () => {

    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { drupal_uid } = useParams(); 
    const location = useLocation();
    const loggedin_uid = localStorage.getItem('drupal_uid');
    const[referrerdetails, setReferrerDetails] = useState({});
     const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        comment: '',
        price_amount: '',
        drupal_uid:drupal_uid
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => { 
        Promise.all([
            getreferrerdetails()
            ]).then(() => {
     
                setIsLoading(false);
            })   
    },[]);
    async function getreferrerdetails() {
        try {
            const response = await fetch(
                app_url+'referral/getreferrerdetails?drupal_uid='+drupal_uid,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setReferrerDetails(responsedata.data.result);
            } 
        } catch (error) {
            console.error(error);
        }finally {
            
        }    
    }
    const validate = (data) => {
        const newErrors = {};
        const priceRegex = /^[0-9]+$/;
        // const priceRegex = /^\\d*\\.?\\d*$/;

        if (!data.price_amount) {
        // alert(' is required');
            newErrors.price_amount = 'Amount is required';
            //return false;
        }
        if (!data.comment)  { 
        // alert('Last Name is required');
            newErrors.comment = 'Comment is required';
        // return false;
        }
        if (data.price_amount && !priceRegex.test(data.price_amount)) {
            newErrors.price_amount = "Amount field must contain only numbers";
        }
        return newErrors;
    }
    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        const formErrors = validate(formData);
        if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return;
  } else {
       const response = await fetch(app_url+'referral/putcashout', {
        method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
        navigate('/manage-referrals', { state: { message: data.data.result } });
      }
    }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    {loggedin_uid && !Number.isNaN(loggedin_uid) ? (
                        <>
                            <Helmet><title>Cash Out</title></Helmet>
                            <div className="left"></div>
                            <div className="center left-center">
                                <div className="cash-out-container">
                                    <div>
                                        <div><b>First Name:</b> {referrerdetails.first_name}</div>
                                        <div><b>Last Name:</b> {referrerdetails.last_name}</div>
                                        <div><b>E-Mail:</b> {referrerdetails.email}</div>
                                        <div><b>Balance Amount:</b> ${referrerdetails.bonus_amount}</div>
                                    </div>
                                    <form onSubmit={handleSubmit}> 
                                        <label>Please Enter a Comment</label>
                                        <textarea 
                                            name="comment" 
                                            value={formData.comment}
                                            onChange={handleChange}
                                            rows={4} 
                                            cols={50} 
                                            // required
                                        >
                                        </textarea>
 {errors.comment &&
                  <span className="error-message" style={{marginTop:"0px"}}>
                  {errors.comment}
                  </span>
                  }        
                                        <label>Amount</label>
                                        <input 
                                            type="text" 
                                            name="price_amount" 
                                            id="price_amount" 
                                            value={formData.price_amount}
                                            onChange={handleChange}
                                            // required 
                                        />
                                        {errors.price_amount &&
                  <span className="error-message" style={{marginTop:"0px"}}>
                  {errors.price_amount}
                  </span>
                  }        
                                        <input type="submit" value="Submit" name="submit" />
                                    </form>
                                </div>
                            </div>
                            <div className="right">
                                <SalespersonSidebar />
                            </div>
                        </>
                    ) : (
                        <><p>You are not authorized</p></>   
                    )}
                </div>
            )}
        </>
    );
};
export default CashOut;